export interface LoadStatus {
  id: string;
  key: string;
  title: string;
  completion_pct: number;
}

export interface BoardLoad {
  id: string;
  order_no: string;
  client: string | null;
  destination: string | null;
  grade: string | null;
  packaging_type: string | null;
  loading_local: string | null;
  load_date: string | null;
  lot: string[] | null;
  phone: string | null;
  pager: number | null;
  updated_at: string;
  status: LoadStatus | null;
  driver: { first_name: string | null; last_name: string | null } | null;
  carrier: { name: string } | null;
  tractor: { registration: string | null } | null;
  trailer: { registration: string | null } | null;
}

export const statusLabels: Record<string, string> = {
  pending: 'Pendente', accepted: 'Aceite', rejected: 'Rejeitada',
  truck_waiting: 'Em espera', gateway: 'Na portaria', loading: 'Em carga',
  expedition: 'Em expedição', expedited: 'Expedida', delivered: 'Entregue',
};

export function statusLabel(status: LoadStatus | null) {
  return status ? statusLabels[status.key] ?? status.title : 'Sem estado';
}

export function driverName(row: BoardLoad) {
  return [row.driver?.first_name, row.driver?.last_name].filter(Boolean).join(' ');
}

export function lisbonDate(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Lisbon', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(date);
}

export function shiftDay(day: string, delta: number) {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + delta);
  return date.toISOString().slice(0, 10);
}

export function formatTime(value: string) {
  const date = new Date(value);
  return Number.isNaN(date.valueOf()) ? '—' : new Intl.DateTimeFormat('pt-PT', {
    timeZone: 'Europe/Lisbon', hour: '2-digit', minute: '2-digit',
  }).format(date);
}

export function formatDay(value: string | null) {
  if (!value) return 'Sem data';
  const date = new Date(`${value}T12:00:00Z`);
  return Number.isNaN(date.valueOf()) ? 'Sem data' : new Intl.DateTimeFormat('pt-PT').format(date);
}

export function filterLoads(rows: BoardLoad[], day: string, query: string, status = 'all') {
  const normalize = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const search = normalize(query.trim());
  return rows.filter((row) => {
    if (day && row.load_date !== day) return false;
    if (status !== 'all' && (row.status?.id ?? 'unset') !== status) return false;
    const text = [row.order_no, row.client, row.destination, row.grade, row.loading_local,
      row.carrier?.name, row.tractor?.registration, row.trailer?.registration,
      driverName(row), row.phone, ...(row.lot ?? [])].filter(Boolean).join(' ');
    return !search || normalize(text).includes(search);
  });
}
